import React from 'react'
import {Link} from 'react-router-dom'

import {injectCartContainer} from '../../react/CartContainer'
import {injectShopContainer} from '../../react/ShopDataContainer'
import makeCloudinaryUrlForPhoto from '../../react/makeCloudinaryUrlForPhoto'

// Sticky ordering-app top bar (menu / product / cart pages), Baldwin-style.
// The logo link is a plain <a href="/">: the site root is the Astro marketing
// homepage, served by Netlify entirely outside this React app (see
// ./_redirects), so it must be a full-page navigation, not a <Link>.
function CartBar ({cart, shop}) {
  if (!shop) { return null }

  const numberOfItems = (cart.state.products || []).length
  const logoUrl = shop.logo && makeCloudinaryUrlForPhoto(shop.logo, {height: 200})

  return (
    <div role="navigation" aria-label="primary" className="cart-wrapper">
      <div className="cart minimized">
        <div className="home-link-wrapper">
          <a href="/" className="home-link" aria-label="Los Amigos home">
            {logoUrl ?
              <img
                className="nav-bar-logo"
                src={logoUrl}
                alt="Los Amigos Mexican Restaurant" /> :
              <span className="nav-bar-brand">
                Los Amigos
                <small>MEXICAN RESTAURANT</small>
              </span>}
          </a>
        </div>

        <div className="tool-bar">
          <Link
            aria-label="shopping cart"
            to={{pathname: "/checkout", state: {fromMini: true}}}
            className="checkout-button button">cart ({numberOfItems})</Link>
        </div>
      </div>
    </div>
  )
}

export default injectCartContainer(injectShopContainer(CartBar))
